import React from "react";
import VerificationInput from "./VerificationInput";
import { t } from "i18next";

const Form = (props) => {
  const {
    verificationCode,
    handleChange,
    seconds,
    error,
    resendCode,
  } = props;

  const handleFormSubmit = (event) => {
    event.preventDefault();
  };
  return (
    <form id="verification-form" onSubmit={handleFormSubmit}> 
      <div className="py-6 l-d">
        <div className="text-center">
          <VerificationInput
            id={verificationCode}
            value={verificationCode}
            handleChange={handleChange}
          />
        </div>

        {error && (
          <div className="text-red-500 text-center mt-2">
            {typeof error === "string"
              ? error
              : error.message
              ? error.message
              : t("Something was incorrect.")}
          </div>
        )}
      </div>
      {seconds > 0 ? (
        <div className="text-center">
          <span className=" text-sm  text-15x ">
            {t("I haven't received the code")} • {seconds} {t("sec")}
          </span>
        </div>
      ) : (
        <div className="text-center cursor-pointer" onClick={resendCode}>
          <span className=" text-sm underline text-15x text-brand-base-primary cursor-pointer">
            {t("I haven't received the code")}
          </span>
        </div>
      )}
    </form>
  );
};

export default Form;
